var map = {
	"./bajaj/logo-cotizacion.png": "1e22",
	"./honda/logo-cotizacion.png": "6de0",
	"./husqvarna/logo-cotizacion.png": "909c",
	"./ktm/logo-cotizacion.png": "41fb",
	"./kymco/logo-cotizacion.png": "12ee",
	"./morbidelli/logo-cotizacion.png": "d1e1",
	"./royal enfield/logo-cotizacion.png": "dcfa",
	"./suzuki/logo-cotizacion.png": "fb40",
	"./triumph/logo-cotizacion.png": "18fc",
	"./tvs/logo-cotizacion.png": "7c6e",
	"./voge/logo-cotizacion.png": "77fa",
	"./zongshen/logo-cotizacion.png": "41e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ee0";